<div data-testid="multi-scanner" class="inventory-multi-scanner relative w-full h-full min-h-0 overflow-hidden" [class.drawer-open]="drawerOpen">

  <main class="scanner-body relative w-full h-full min-h-0 overflow-hidden">
    <section class="camera-stage absolute overflow-hidden">
      <div #uiWrapper data-testid="multi-scanner-camera-ui" class="camera-ui relative w-full h-full min-h-0 overflow-hidden"></div>

      @if (showCameraState) {
        <div data-testid="multi-scanner-camera-state" class="camera-state absolute flex flex-col items-center justify-center gap-4 text-sm">

          @if (showCameraStartGuide) {
            <section id="splash-screen" data-testid="multi-scanner-start-guide">
              <div class="gray-card" data-testid="multi-scanner-quick-guide-card">
                <h2 data-testid="multi-scanner-quick-guide-title">
                  {{ 'CAMERA_SCANNER.QUICK_GUIDE' | translate }}
                </h2>

                <ol data-testid="multi-scanner-quick-guide-steps">
                  <li data-testid="multi-scanner-quick-guide-step-1">
                    {{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_01' | translate }}
                  </li>
                  <li data-testid="multi-scanner-quick-guide-step-2">
                    {{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_02' | translate }}
                  </li>
                  <li data-testid="multi-scanner-quick-guide-step-3">
                    {{ 'CAMERA_SCANNER.QUICK_GUIDE_STEP_03' | translate }}
                  </li>
                </ol>
              </div>
              <div class="start-scanning">
                <button data-testid="multi-scanner-start-scanning-btn" class="btn primary-btn w-100" type="button" (click)="toggleCamera()">
                  {{ 'CAMERA_SCANNER.BTN_START_SCANNING' | translate }}
                </button>
              </div>
            </section>
          } @else {
            <div class="text-center" data-testid="multi-scanner-camera-message">
              <p class="font-semibold" data-testid="multi-scanner-camera-message-title">{{ cameraStatusTitle }}</p>
              @if (cameraStatusDescription) {
                <p class="mt-1" data-testid="multi-scanner-camera-message-description">{{ cameraStatusDescription }}</p>
              }
            </div>

            @if (showCameraActionButton) {
              <button data-testid="multi-scanner-camera-action-btn" type="button" class="btn primary-btn" (click)="openCamera()">
                {{ cameraActionButtonLabel }}
              </button>
            }

            @if (showManualEntryButton) {
              <button data-testid="multi-scanner-camera-manual-entry-btn" type="button" class="btn outline-btn" (click)="openManualEntry()">
                {{ 'CAMERA_SCANNER.BTN_MANUAL_ENTRY' | translate }}
              </button>
            }
          }
        </div>
      }

      @if (showCameraSelector && isCameraOpen) {
        <div data-testid="multi-scanner-camera-selector" class="camera-selector absolute">

          <select  data-testid="multi-scanner-camera-selector-select" [value]="selectedCameraId" (change)="onCameraChange($event)">

            <option value="" disabled>
              {{ 'CAMERA_SCANNER.PLACEHOLDER_SELECT_CAMERA' | translate }}
            </option>

            @for (camera of camerasList; track camera; let cameraIndex = $index) {
              <option [attr.data-testid]="'multi-scanner-camera-option-' + cameraIndex" [value]="camera.deviceId">
                {{ camera.label || ('CAMERA_SCANNER.CAMERA_FALLBACK_LABEL' | translate) }}
              </option>
            }
          </select>
        </div>
      }

      @if (duplicateScanMessage) {
        <div data-testid="multi-scanner-duplicate-message" class="duplicate-scan-message text-sm">
          {{ duplicateScanMessage }}
        </div>
      }
    </section>
    <section data-testid="multi-scanner-recent-scans-drawer" class="recent-scans-drawer absolute flex flex-col min-h-0 overflow-hidden">
      <button data-testid="multi-scanner-drawer-toggle-btn" type="button" class="drawer-handle flex items-center justify-center w-full" [attr.aria-label]="'CAMERA_SCANNER.DRAWER_TOGGLE_ARIA_LABEL' | translate" [attr.aria-expanded]="drawerOpen" (click)="toggleDrawer()">
        <span aria-hidden="true"></span>
      </button>
      <div data-testid="multi-scanner-drawer-summary" class="drawer-summary-wr flex items-center justify-between gap-3 shrink-0">
        <button data-testid="multi-scanner-drawer-summary-toggle-btn" type="button" class="drawer-summary-content flex flex-col gap-1" [attr.aria-expanded]="drawerOpen" (click)="toggleDrawer()">
          <span class="flex flex-wrap items-center gap-2">
            <strong class="text-base" data-testid="multi-scanner-recent-scans-title">
              {{ 'CAMERA_SCANNER.RECENT_SCANS' | translate }}
            </strong>
            <span data-testid="multi-scanner-scanned-count" class="count-pill text-sm inline-flex items-center justify-center shrink-0 whitespace-nowrap">
              {{ 'CAMERA_SCANNER.SCANNED_COUNT' | translate:{ count: scannedItems.length } }}
            </span>
          </span>
          <span class="drawer-description text-sm" data-testid="multi-scanner-recent-scans-description">
            {{ 'CAMERA_SCANNER.RECENT_SCANS_DESCRIPTION' | translate }}
          </span>
        </button>
        <div class="drawer-summary-actions flex items-center justify-end gap-3 shrink-0">
          <button data-testid="multi-scanner-manual-entry-btn" type="button" class="btn outline-btn" (click)="openManualEntry()">
            {{ 'CAMERA_SCANNER.BTN_MANUAL_ENTRY' | translate }}
          </button>
          <button data-testid="multi-scanner-finish-btn" type="button" class="btn primary-btn" [disabled]="!scannedItems.length" (click)="onFinishClick()">
            {{ 'CAMERA_SCANNER.BTN_FINISH' | translate }}
          </button>
        </div>
      </div>
      @if (drawerOpen && manualEntryOpen) {
        <div data-testid="multi-scanner-manual-entry" class="manual-entry flex items-start gap-3">

          <div class="manual-entry-field flex flex-col flex-1">
            <input data-testid="multi-scanner-manual-entry-input" type="text" class="w-full" [(ngModel)]="manualSerialNumber" [placeholder]="'CAMERA_SCANNER.PLACEHOLDER_ENTER_SERIAL_NUMBER' | translate" autocomplete="off" (keydown.enter)="addManualEntry()" />
            @if (manualEntryError) {
              <small data-testid="multi-scanner-manual-entry-error" class="p-error">
                {{ manualEntryError }}
              </small>
            }
          </div>

          <div class="manual-entry-actions flex justify-end gap-2">
            <button
              data-testid="multi-scanner-manual-entry-cancel-btn"
              type="button"
              class="btn outline-btn"
              (click)="cancelManualEntry()">
              {{ 'CAMERA_SCANNER.BTN_CANCEL' | translate }}
            </button>

            <button
              data-testid="multi-scanner-manual-entry-add-btn"
              type="button"
              class="btn primary-btn"
              [disabled]="!manualSerialNumber.trim()"
              (click)="addManualEntry()">
              {{ 'CAMERA_SCANNER.BTN_ADD' | translate }}
            </button>
          </div>
        </div>
      }

      @if (drawerOpen) {
        <div data-testid="multi-scanner-scan-list" class="scan-list min-h-0 overflow-y-auto">

          @if (scannedItems.length) {
            @for (
              item of paginatedScannedItems;
              track trackByItemId($index, item);
              let itemIndex = $index
            ) {
              <div class="scan-row flex items-center justify-between gap-4" [attr.data-testid]="'multi-scanner-scan-row-' + itemIndex">

                <div class="scan-row-content flex flex-col">
                  <span class="text-sm serial-number break-words" [attr.data-testid]="'multi-scanner-scan-row-serial-number-' + itemIndex">
                    {{ item.serialNumber }}
                  </span>
                </div>

                <button type="button" class="btn borderless-btn btn-icon icon-trash inline-flex items-center justify-center shrink-0" [attr.data-testid]="'multi-scanner-remove-scan-btn-' + itemIndex" pTooltip="{{ 'INVENTORY_SINGLE_VIEW.REMOVE_ITEM' | translate }}" tooltipPosition="top" (click)="removeItem(item)">
                </button>
              </div>
            }

            <app-custom-paginator
              data-testid="multi-scanner-paginator"
              class="multi-scanner-paginator"
              [pageNumber]="scannedItemsPaginatorPageNumber"
              [rows]="scannedItemsPaginatorRows"
              [totalRecords]="scannedItemsTotalRecords"
              [rowsPerPageOptions]="[10, 20, 30]"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
              [disabled]="!scannedItemsTotalRecords"
              [alwaysShow]="false"
              [showFirstLastIcon]="true"
              [showPageLinks]="true"
              [showPageSizeSelector]="false"
              tableName="multi-scanner-scanned-items"
              (onPageChange)="onScannedItemsPageChange($event)">
            </app-custom-paginator>
          } @else {
            <div
              data-testid="multi-scanner-empty-scans"
              class="empty-scans flex items-center justify-center text-center text-sm">
              {{ 'CAMERA_SCANNER.EMPTY_SCANS' | translate }}
            </div>
          }
        </div>
      }
    </section>
  </main>
</div>
